if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        // Keep the existing error panel visible when the mobile bar hides source CTAs.
        if (this.closest('.torras-main-product')) {
          this.errorMessageWrapper = this.querySelector('.product-form__error-message-wrapper') || this.closest('.torras-main-product').querySelector('.product-form__error-message-wrapper');
          const actions = this.errorMessageWrapper?.closest('.torras-main-product__actions');
          if (actions) {
            this.errorMessage = this.errorMessageWrapper.querySelector('.product-form__error-message');
            actions.before(this.errorMessageWrapper);
          }
        }
      }

      trackAnalyticsResult(result) {
        const interactionName = this.submitButton?.dataset?.analyticsInteractionName;
        if (!interactionName || this.analyticsResultTrackedForSubmission) return;

        this.analyticsResultTrackedForSubmission = true;
        window.TorrasAnalytics?.trackInteraction(this.submitButton, {
          elementType: this.submitButton.dataset.analyticsElementType || 'cta',
          elementId: this.submitButton.dataset.analyticsElementId,
          elementPosition: this.submitButton.dataset.analyticsElementPosition,
          interactionName,
          interactionResult: result,
        });

        if (
          this.analyticsStickyAtcForSubmission
        ) {
          window.TorrasAnalytics?.trackInteraction(this.submitButton, {
            componentId: 'pdp_sticky_atc',
            componentType: 'add_to_cart',
            elementType: 'cta',
            elementId: 'add_to_cart',
            elementPosition: 1,
            interactionName,
            interactionResult: result,
          });
        }
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        this.analyticsResultTrackedForSubmission = false;
        this.analyticsStickyAtcForSubmission =
          this.submitButton.dataset.analyticsStickyAtc === 'true' &&
          window.matchMedia('(min-width: 750px)').matches;

        this.handleErrorMessage();

        const activeElement = document.activeElement;
        const cartAssetsReady =
          this.cart && window.TorrasDeferredUI && typeof window.TorrasDeferredUI.loadCart === 'function'
            ? window.TorrasDeferredUI
                .loadCart()
                .then(() => true)
                .catch((error) => {
                  console.error(error);
                  return false;
                })
            : Promise.resolve(true);

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const queuedPurchase = evt.detail && evt.detail.torrasPurchase;
        const formData = queuedPurchase ? queuedPurchase.formData : new FormData(this.form);
        const mainVariantId = queuedPurchase ? queuedPurchase.variantId : formData.get('id');
        const hasPairing = queuedPurchase ? queuedPurchase.hasPairing : document.getElementById('Pairings-' + this.form.getAttribute('id'))?.appendToCartData(formData);
        if (this.cart) {
          const sectionsToRender =
            typeof this.cart.getSectionsToRender === 'function'
              ? this.cart.getSectionsToRender()
              : [{ id: 'cart-drawer' }, { id: 'cart-icon-bubble' }];
          formData.append(
            'sections',
            sectionsToRender.map((section) => section.id).join(',')
          );
          formData.append('sections_url', window.location.pathname);
          if (typeof this.cart.setActiveElement === 'function') {
            this.cart.setActiveElement(activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (hasPairing && response.items) {
              const mainItem = response.items.find((item) => String(item.id) === mainVariantId);
              response = { ...response, id: mainItem?.id, key: mainItem?.key };
            }
            if (response.status) {
              this.trackAnalyticsResult('error');
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: mainVariantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              if (hasPairing) {
                this.error = false;
                return;
              }

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            }

            this.trackAnalyticsResult('success');
            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (
              response.item_count != null &&
              window.Torras &&
              typeof window.Torras.updateCloneHeaderCartBadge === 'function'
            ) {
              window.Torras.updateCloneHeaderCartBadge(response.item_count);
            }

            return cartAssetsReady.then((cartIsReady) => {
              if (!cartIsReady || typeof this.cart.renderContents !== 'function') {
                window.location = window.routes.cart_url;
                return;
              }

              if (typeof this.cart.setActiveElement === 'function') {
                this.cart.setActiveElement(activeElement);
              }

              const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
              if (!this.error)
                publish(PUB_SUB_EVENTS.cartUpdate, {
                  source: 'product-form',
                  productVariantId: mainVariantId,
                  cartData: response,
                }).then(() => {
                  CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
                });
              this.error = false;
              const quickAddModal = this.closest('quick-add-modal');
              if (quickAddModal) {
                document.body.addEventListener(
                  'modalClosed',
                  () => {
                    setTimeout(() => {
                      CartPerformance.measure('add:paint-updated-sections', () => {
                        this.cart.renderContents(response);
                      });
                    });
                  },
                  { once: true }
                );
                quickAddModal.hide(true, 'action_complete', 'success');
              } else {
                CartPerformance.measure('add:paint-updated-sections', () => {
                  this.cart.renderContents(response);
                });
              }
            });
          })
          .catch((e) => {
            this.trackAnalyticsResult('error');
            if (hasPairing) {
              this.error = false;
              this.handleErrorMessage(window.cartStrings.error);
            }
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
